module.exports = __webpack_public_path__ + "assets/img/facebook_1299.894ab12b.png";